<template>
  <footer class="footer text-center">
    <div>
      <p class="paragrafo">© 2024 RD Station Conversas | 13.021.784/0001-86</p>
    </div>
    
  </footer>
</template>

<script>
export default {
  name: "FooterTallosInformations",
  data() {
    return {};
  },
};
</script>

<style scoped>
.footer {
  position: inherit;
  max-width: 100%;
  width: 100vw;
}
.paragrafo {
  color: #868C94;
  margin: 1rem;
}
</style>